import { CandidatePreferenceUpdateMode } from '@/shared/constants/candidate/CandidatePreferenceUpdateMode'

/**
 * Locations a client can actually control; disabled locations are read-only.
 */
export function getEditableLocations(client) {
  return client.locations.filter((location) => !location.isDisabled)
}

/**
 * Serializes a changed client into the request's location-level update mode. Every non-empty
 * selection is sent as explicit location ids - there is no client-level "all locations" mode.
 */
export function buildClientPreferenceChange(client) {
  const editableLocations = getEditableLocations(client)
  const preferredLocationIds = editableLocations
    .filter((location) => location.isPreferred)
    .map((location) => location.locationId)

  const mode =
    preferredLocationIds.length === 0
      ? CandidatePreferenceUpdateMode.None
      : CandidatePreferenceUpdateMode.Locations

  return {
    clientId: client.clientId,
    mode,
    preferredLocationIds,
  }
}

const UnpreferredRestrictionReasons = Object.freeze([
  'ClientExcluded',
  'ClientGroupExcluded',
])

function isClientRestrictedByUnpreferredLink(client) {
  return UnpreferredRestrictionReasons.includes(client.disabledReason)
}

/**
 * Explicit unpreferred restrictions require consultant intervention and are shown last.
 */
export function sortClientsWithUnpreferredRestrictionsLast(clients) {
  return [...clients].sort((clientA, clientB) => {
    const isClientARestricted = isClientRestrictedByUnpreferredLink(clientA)
    const isClientBRestricted = isClientRestrictedByUnpreferredLink(clientB)

    if (isClientARestricted === isClientBRestricted) return 0
    return isClientARestricted ? 1 : -1
  })
}
